import { createFileRoute } from "@tanstack/react-router";
import { IntegrationDetailPage } from "@/features/integrations/integration-detail-page";

export const Route = createFileRoute("/_authenticated/integrations/$integrationId")({
  head: () => ({ meta: [{ title: "Integration · Rogue Admin" }] }),
  component: IntegrationDetailPage,
});
